import { useContext } from 'react';
import IgnoreBreadcrumbContext from 'common/contexts/IgnoreBreadcrumbContext';

export default function useIgnoreBreadcrumbContext() {
  return useContext(IgnoreBreadcrumbContext);
}
